import React, { useState, useEffect } from "react";
import "./SidebarToAnnotationLine.css";

const SidebarToAnnotationLine = (props) => {
  const {
    showLine,
    docViewer,
    zoomLevel,
    sidebarRef,
    setShowLine,
    pdfViewerRef,
    annotationRefs,
    selectedAnnotation,
  } = props;

  //Right Horizontal Line
  const [rightHorizontalLineWidth, setRightHorizontalLineWidth] = useState(0);
  const [rightHorizontalLineTop, setRightHorizontalLineTop] = useState(0);
  const [rightHorizontalLineLeft, setRightHorizontalLineLeft] = useState(0);

  //Left Horizontal Line
  const [leftHorizontalLineWidth, setLeftHorizontalLineWidth] = useState(0);
  const [leftHorizontalLineTop, setLeftHorizontalLineTop] = useState(0);
  const [leftHorizontalLineLeft, setLeftHorizontalLineLeft] = useState(0);

  const [annotation, setAnnotation] = useState(null);

  const getAnnotationPageCoordinates = (annotation) => {
    const rect = annotation.getRect();
    let { x1: left, y1: top, x2: right, y2: bottom } = rect;

    const rotation = docViewer.getCompleteRotation(annotation.PageNumber);
    if (rotation === 1) {
      [top, bottom] = [bottom, top];
    } else if (rotation === 2) {
      [left, right] = [right, left];
      [top, bottom] = [bottom, top];
    } else if (rotation === 3) {
      [left, right] = [right, left];
    }

    return { left, top, right, bottom };
  };

  const getAnnotationPosition = (annotation) => {
    const { left, top, right, bottom } = getAnnotationPageCoordinates(
      annotation
    );

    const pageNumber = annotation.getPageNumber();
    const topLeft = convertPageCoordinatesToWindowCoordinates(
      left,
      top,
      pageNumber
    );
    let bottomRight = convertPageCoordinatesToWindowCoordinates(
      right,
      bottom,
      pageNumber
    );

    return { topLeft, bottomRight };
  };

  const convertPageCoordinatesToWindowCoordinates = (x, y, pageNumber) => {
    const displayMode = docViewer.getDisplayModeManager().getDisplayMode();
    return displayMode.pageToWindow({ x, y }, pageNumber);
  };

  const getAnnotationLineOffset = () => {
    if (annotation.Subject === "Note") {
      return 4;
    }
    return 15;
  };

  const calculation = () => {
    const {
      bottomRight: annotationBottomRight,
      topLeft: annotationTopLeft,
    } = getAnnotationPosition(annotation);

    // const annotWidthInPixels = annotationBottomRight.x - annotationTopLeft.x;
    const annotHeightInPixels = annotationBottomRight.y - annotationTopLeft.y;

    const { scrollTop, scrollLeft } = docViewer.getScrollViewElement();
    const annotationSideBarRightPadding = 16;
    const notePanelWidth = sidebarRef.current.clientWidth;

    setRightHorizontalLineLeft(notePanelWidth - annotationSideBarRightPadding);

    let currentAnnotationContainer = annotationRefs[selectedAnnotation].current;
    setRightHorizontalLineTop(
      currentAnnotationContainer.getBoundingClientRect().top +
        currentAnnotationContainer.clientHeight / 2
    );

    const headerToPdfLeft = pdfViewerRef.current.offsetLeft;

    const lineWidth =
      headerToPdfLeft -
      notePanelWidth +
      annotationSideBarRightPadding +
      annotationTopLeft.x -
      scrollLeft;

    const rightHorizontalLineWidthRatio = 0.75;

    const rightHorizontalLineWidthLocal =
      lineWidth * rightHorizontalLineWidthRatio;

    setRightHorizontalLineWidth(rightHorizontalLineWidthLocal);

    setLeftHorizontalLineWidth(
      lineWidth - rightHorizontalLineWidthLocal - getAnnotationLineOffset()
    );

    setLeftHorizontalLineLeft(
      notePanelWidth -
        annotationSideBarRightPadding +
        rightHorizontalLineWidthLocal
    );

    const headerToPdfHeight = pdfViewerRef.current.offsetTop;
    const leftHorizontalLineTopLocal =
      headerToPdfHeight +
      annotationTopLeft.y -
      scrollTop +
      annotHeightInPixels / 2;
    setLeftHorizontalLineTop(leftHorizontalLineTopLocal);
  };

  useEffect(() => {
    if (annotation && annotationRefs[selectedAnnotation].current) {
      calculation();
    }
  }, [annotation, zoomLevel]);

  useEffect(() => {
    if (selectedAnnotation && docViewer) {
      let annotation = docViewer
        .getAnnotationManager()
        .getAnnotationById(selectedAnnotation);
      setAnnotation(annotation);
    }
  }, [selectedAnnotation]);

  const scrollEvent = () => {
    setShowLine(false);
  };

  // to remove the line of window click or scroll
  useEffect(() => {
    window.addEventListener("scroll", scrollEvent, true);
    window.addEventListener("click", scrollEvent);
    return () => {
      window.removeEventListener("scroll", scrollEvent);
      window.removeEventListener("click", scrollEvent);
    };
  }, []);

  const verticalHeight = Math.abs(
    rightHorizontalLineTop - leftHorizontalLineTop
  );
  const horizontalLineHeight = 2;
  // Add HorizontalLineHeight of 2px when annot is above note to prevent little gap between lines
  const verticalTop =
    rightHorizontalLineTop > leftHorizontalLineTop
      ? leftHorizontalLineTop + horizontalLineHeight
      : rightHorizontalLineTop;

  return (
    <React.Fragment>
      {showLine && (
        <React.Fragment>
          <div
            className="horizontalLine"
            style={{
              width: rightHorizontalLineWidth,
              left: rightHorizontalLineLeft,
              top: rightHorizontalLineTop,
            }}
          />
          <div
            className="verticalLine"
            style={{
              height: verticalHeight,
              top: verticalTop,
              left: rightHorizontalLineLeft + rightHorizontalLineWidth,
            }}
          />
          <div
            className="horizontalLine"
            style={{
              width: leftHorizontalLineWidth,
              left: leftHorizontalLineLeft,
              top: leftHorizontalLineTop,
            }}
          >
            <div className="arrowHead" />
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default SidebarToAnnotationLine;
